import { useBoundary } from '../Boundary';
import { regions } from './constants';
import DefaultRegion from './DefaultRegion';
const regionNames = regions.map(_ref => {
  let {
    displayName
  } = _ref;
  return displayName;
});

/**
 * @ignore - do not document.
 *
 * Identifies which region a component is placed in.
 *
 * @returns {string} Returns the name of the region where the component that called the hook is inserted.
 */
export default function useRegion() {
  const {
    findNearestBoundary
  } = useBoundary();
  return findNearestBoundary(...regionNames) || DefaultRegion.displayName;
}